module.exports = __webpack_public_path__ + "img/RHDesign.8ff3b44b.webp";